import { c as _c } from "react/compiler-runtime";
import { VStack } from '@chakra-ui/react';
import { UserAccessGateCTAProps } from '@src/components/sco/UserAccessGate';
import { BoxedCardCTA } from '@src/components/sco/UserAccessGate/cta-variants/BoxedCardCTA';
import React from 'react';
export const BoxedCardOverImageCTA = props => {
  const $ = _c(9);
  const t0 = props.bgImageUrl || null;
  let t1;
  if ($[0] !== props.wrapperProps) {
    t1 = props.wrapperProps || {};
    $[0] = props.wrapperProps;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  let t2;
  if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = {};
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  let t3;
  if ($[3] !== props) {
    t3 = <VStack bgColor="blackAlpha.800" height="full" justify="center" overflow="auto" padding="1em" width="full"><BoxedCardCTA {...props} wrapperProps={t2} /></VStack>;
    $[3] = props;
    $[4] = t3;
  } else {
    t3 = $[4];
  }
  let t4;
  if ($[5] !== t0 || $[6] !== t1 || $[7] !== t3) {
    t4 = <VStack bgImage={t0} bgPosition="center" bgSize="cover" height="full" justify="center" width="full" {...t1}>{t3}</VStack>;
    $[5] = t0;
    $[6] = t1;
    $[7] = t3;
    $[8] = t4;
  } else {
    t4 = $[8];
  }
  return t4;
};